// Instructor management routes
import InstructorsList from '../../components/InstructorsList.vue'
import InstructorDetails from '../../components/InstructorDetails.vue'
import InstructorDetailsView from '../../views/InstructorDetailsView.vue'
import InstructorKeywords from '../../components/InstructorKeywords.vue'
import InstructorEditPage from '../../components/instructor-details/InstructorEditPage.vue'
import InstructorQuickUpdate from '../../components/instructor-details/InstructorQuickUpdate.vue'

export default [
  {
    path: '/instructor-list',
    name: 'InstructorList',
    component: InstructorsList,
    meta: { 
      requiresAuth: true,
      title: 'Instructor List'
    }
  },
  {
    path: '/instructor-details',
    name: 'InstructorDetails',
    component: InstructorDetails,
    meta: { 
      requiresAuth: true,
      title: 'Instructor Details'
    }
  },
  {
    path: '/instructors/:id',
    name: 'InstructorDetailsView',
    component: InstructorDetailsView,
    meta: { 
      requiresAuth: true,
      title: 'Instructor Profile'
    }
  },
  {
    path: '/instructor-keywords',
    name: 'InstructorKeywords',
    component: InstructorKeywords,
    meta: { 
      requiresAuth: true,
      title: 'Instructor Keywords'
    }
  },
  {
    path: '/instructor-details/:id/edit',
    name: 'InstructorEdit',
    component: InstructorEditPage,
    props: route => ({ instructorId: route.params.id }),
    meta: { 
      requiresAuth: true,
      title: 'Edit Instructor'
    }
  },
  {
    path: '/instructor-update',
    name: 'InstructorQuickUpdate',
    component: InstructorQuickUpdate,
    meta: { 
      requiresAuth: true,
      title: 'Quick Update Instructor'
    }
  }
] 